/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const NEXT_STEP = 'NEXT_STEP'
export const PREVIOUS_STEP = 'PREVIOUS_STEP'
export const SET_STEPS = 'SET_STEPS'

export const nextStep = () => {
  return {
    type: NEXT_STEP,
  }
}

export const previousStep = () => {
  return {
    type: PREVIOUS_STEP,
  }
}

export const setSteps = (steps: string[]) => {
  return {
    type: SET_STEPS,
    steps,
  }
}
